export enum promoBannerRedirectOption {
  JUMP_TO_OTHER_PAGE = 1,
  WINDOW_OPEN = 2
}

export default promoBannerRedirectOption
